import { StudentIncidentNoteNameFragment } from "../../../Utilities";
import * as Fields from "./fields";

export { Fields };

/**
 * Formats the full name of the given instance.
 */
export function name(instance: StudentIncidentNoteNameFragment) {
	return instance.id;
}

export const fieldLabels = {
	incidentTime: "When did this incident happen?",
	incidentLocation: "Where did this incident happen?",
	actionsTaken: "Describe what actions have been taken in response to this incident",
	suggestionsForFuture: "What suggestions do you have to deal with or avoid this type of incident in the future?",
};
